/**
 * De vier abilities die NovaMund al heeft, onder de naam die gbrain ze geeft.
 * Post d, MASTERPLAN 3ax-10. Franks besluit: *"Dat is het goedkoopste punt op
 * de lijst en het staat nu verstopt."*
 *
 * ER WORDT HIER NIETS NIEUWS GEBOUWD. Elke regel noemt wat er in NovaMund AL is
 * (gemeten op 1 september 2026) en waar je het vindt. Een ability die hier staat
 * zonder dat het onderdeel bestaat, zou een belofte zijn zonder vermogen.
 */
/* GLASRONDE 0.9.189, VONDST 2 (Frank 22 oktober 2026): in het Nederlands stonden de
 * vier namen in het Engels. `naam` is nu de Nederlandse naam en gaat door t(); in het
 * Engels blijft de gbrain-naam staan (taal-en.js). */
export const ABILITIES = [
  {
    naam: "Feitencontrole",
    wat: "Elk antwoord wordt tegen je eigen bronnen gehouden: beweringen, getallen en tijden die niet in het materiaal staan, worden tegengehouden of gemeld.",
    waar: "Onder elk antwoord, in het bronblok.",
    pad: "/",
    knop: "Naar de chat",
  },
  {
    naam: "Gegevens uit tabellen",
    wat: "Tabellen uit je documenten worden heel bewaard; een vraag naar een rij of een getal haalt de cel op, en een telling of som rekent NovaMund zelf uit.",
    waar: "Vraag in de chat naar een rij uit een tabel in je kennisbank.",
    pad: "/knowledge",
    knop: "Naar je kennisbanken",
  },
  {
    naam: "Stresstest voor een tekst",
    wat: "De raad: meerdere modellen lezen dezelfde tekst of vraag en leggen hun bezwaren naast elkaar.",
    waar: "In de chat, met de knop voor de raad naast het invoerveld.",
    pad: "/",
    knop: "Naar de chat",
  },
  {
    naam: "Ideeënvinder",
    wat: "De oogst leest je gesprekken terug en zet wat het onthouden waard lijkt als voorstel klaar. Jij beslist wat blijft.",
    waar: "Op de pagina Geheugen, bij de voorstellen.",
    pad: "/memory",
    knop: "Naar Geheugen",
  },
];
